import React, { Component } from 'react';
import { ConfigProvider, Layout, Icon, Row, Col } from 'antd';
import esES from 'antd/es/locale/es_ES';
import imgBandaTitulo from '../../img/logo_recluta.svg'
import { withRouter } from 'react-router-dom';
import BlockLoader from './Loader.js';
import Footer from './Elements/Footer';

const { Header, Content } = Layout;

class TemplateExterno extends Component {
	render() {
		const bloquear = this.props.bloqueado || this.props.cargando;

		return (
			<ConfigProvider locale={esES}>
				<BlockLoader blocking={bloquear && this.props.bloquearTodo}
					id='template_externo_bloq'
					bloquearTodo={true}>
					<Layout className="layout template_externo">
						<Header className="header_style_externo">
							<a href="/loginSEyCAE">
								<img src={imgBandaTitulo} alt="" className='icono_externo' />
							</a>
						</Header>
						<Content className={this.props.contenidoExpandido ? 'contenido_expandido' : undefined}>
							<BlockLoader blocking={bloquear && !this.props.bloquearTodo}>
								{this.props.children}
							</BlockLoader>
						</Content>
						<Footer />
					</Layout>
				</BlockLoader>
			</ConfigProvider>
		);
	}
}

TemplateExterno.defaultProps = {
	bloqueado: false,
	cargando: false,
	enlaces: true,
	contenidoExpandido: false,
}

export default withRouter(TemplateExterno);
